<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        گزارش کلی اسناد حمل و نقل
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('end_date_id_date_day')"
                                                    first_id="start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    first_id="end_date_id_"
                                                    @last_focus="another_focus_inside('trucks_list_all')"


                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_truck"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :options="trucks_all"
                                            :defaultExpandLevel="1"
                                            id="trucks_list_all"

                                            placeholder="جستجو کامیون"
                                            :normalizer="normalizer_discharge_place"
                                    />
<!--                                    @select="another_focus_inside('load_type_list_all')"-->

                                </v-col>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_load_type"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :defaultExpandLevel="1"
                                            id="load_type_list_all"
                                            :options="load_types_all"
                                            placeholder="جستجو نوع جنس"
                                            :normalizer="normalizer_discharge_place"
                                    />
<!--                                    @select="another_focus_inside('origin_load_list_all')"-->

                                </v-col>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_origin_load"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :defaultExpandLevel="1"
                                            id="origin_load_list_all"
                                            :options="origin_loads_all"
                                            placeholder="جستجو مبدا بارگیری"
                                            :normalizer="normalizer_discharge_place"
                                    />
<!--                                    @select="another_focus_inside('discharge_place_list_all')"-->

                                </v-col>
                                <v-col dir="rtl">
                                    <treeselect
                                            :matchKeys="['code']"
                                            v-model="selected_discharge_place"
                                            :cacheOptions="false"
                                            :multiple="true"
                                            :defaultExpandLevel="1"
                                            id="discharge_place_list_all"
                                            :options="discharge_places_all"
                                            placeholder="جستجو محل تخلیه"
                                            :normalizer="normalizer_discharge_place"
                                    />
<!--                                    @select="another_focus('geT_data_all')"-->

                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data" id="geT_data_all" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>


                            <br>
                            <v-row>
                                <v-col cols="12" :id="body_id">
                                    <VDataTable2
                                            dense
                                            multi-sort
                                            hide-default-footer
                                            disable-pagination
                                            height="400"
                                            fixed-header
                                            v-if="items_delivery.length>0"
                                            class="margin-auto  table-bordered"
                                            :headers="headers_deliver"
                                            :items-per-page="1000"
                                            :items="items_delivery"
                                    >
                                        <template v-slot:item.row_id="{item }">
                                            {{ item._row_index+1}}
                                        </template>
                                        <template v-slot:item.driver_price="{ item }">
                                            {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                        </template>
                                        <template v-slot:item.truck_type="{ item }">
                                            <label v-if="item.truck_type==1">تک</label>
                                            <label v-if="item.truck_type==2">جفت</label>
                                        </template>

                                        <template v-slot:item.real_employer_price="{ item }">
                                            {{ get_currency(item.real_employer_price) }}
                                        </template>
                                        <template v-slot:item.real_driver_price="{ item }">
                                            {{ get_currency( item.real_driver_price) }}
                                        </template>
                                        <template slot="body.append">
                                            <tr class="pink--text">
                                                <th colspan="10" class="title">جمع کل</th>
                                                <th class="title">{{ get_currency(calculate_items(items_delivery,
                                                    'tonaje')) }}
                                                </th>
                                                <th class="title">{{ get_currency(calculate_items(items_delivery,
                                                    'real_tonaje')) }}
                                                </th>
                                            </tr>
                                        </template>
                                    </VDataTable2>

                                </v-col>

                                <v-btn small color="primary"
                                       @click="print_preview_with_header_title_height(body_id,header_id,footer_id,'Deliver Reports')">
                                    پرینت
                                </v-btn>
                                <v-btn small color="success">
                                    <download-excel
                                            class="btn btn-default"
                                            :data="table_excel_with_sum(items_delivery,['tonaje',
'real_tonaje'])"
                                            :fields="table_header_to_excel_heaader(headers_deliver)"
                                            worksheet="My Worksheet"
                                            name="filename.xls"
                                    >
                                        خروجی اکسل
                                    </download-excel>

                                </v-btn>
                            </v-row>

                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <div v-show="false" :id="footer_id" class="border-dark">
            <div>
                <v-row style="border: 1px solid #000">


                    <v-col cols="12" style="text-align: start">
                        <label>{{get_company_address()}}</label>
                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
            <v-col>
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>گزارش کلی اسناد حمل و نقل</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </v-col>

        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ThreeDatePicker from "../includes/ThreeDatePicker";

    export default {
        name: 'OriginDownload',
        components: {
            Treeselect,
            ThreeDatePicker
        },
        data() {
            return {
                tab: null,
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items_delivery: [],
                header_id: "print_header_all_ReportDeliveryDetail" + new Date().getTime() + this.$vnode.tag,
                body_id: "print_body_all_ReportDeliveryDetail" + new Date().getTime() + this.$vnode.tag,
                footer_id: "print_footer_all_ReportDeliveryDetail" + new Date().getTime() + this.$vnode.tag,

                status_form: 0,
                discharge_places: [],
                discharge_places_all: [],
                trucks: [],
                trucks_all: [],
                origin_loads: [],
                origin_loads_all: [],
                load_types: [],
                load_types_all: [],

                selected_truck: [],
                selected_discharge_place: [],
                selected_load_type: [],
                selected_origin_load: [],
                start_date: null,
                end_date: null,
                headers_deliver: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'شماره بارنامه',
                        value: 'barname'
                    },
                    {
                        text: 'شماره پلاک',
                        value: 'truck_plate'
                    },
                    // {
                    //   text: 'نام کامیوندار',
                    //   value: 'truck_driver'
                    // },
                    {
                        text: 'نوع جنس',
                        value: 'load_type'
                    }, {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },{
                        text: 'آدرس',
                        value: 'discharge_place_address'
                    },
                    {
                      text: 'محور',
                      value: 'truck_type'
                    },
                    {
                        text: 'نرخ حمل',
                        value: 'driver_price'
                    },
                    {
                        text: 'تناژ حمل شده',
                        value: 'tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'real_tonaje'
                    },
                    // {
                    //   text: 'مبلغ کارفرما',
                    //   value: 'real_employer_price'
                    // },
                    // {
                    //   text: 'مبلغ راننده',
                    //   value: 'real_driver_price'
                    // },

                ],

                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
            }
        },
        mounted() {
            // this.get_data()

            this.get_discharge_places()
            this.get_trucks()
            this.get_origin_downloads()
            this.get_load_types()
            this.start_date = this.miladi_to_jalali(this.get_today())
            this.end_date = this.miladi_to_jalali(this.get_today())

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {
            // start_date: function () {
            //   this.get_data()
            // },
            // end_date: function () {
            //   this.get_data()
            // },
            //
            // selected_discharge_place: function () {
            //   this.get_data()
            // },

        },
        methods: {

            limited_tonaje(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return tonaje;
            },
            real_paying_driver(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)
            },
            deliver_employer(item) {

                var price = item.employer_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)

            },

            get_data() {
                // if (this.selected_discharge_place == null) {
                //     return
                // }
                this.get_delivery()

            },
            get_delivery() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                //***************************************************

                if (this.selected_discharge_place.includes(0)) {
                    var final_discharge = [];
                    this.discharge_places.forEach(function (val) {
                        final_discharge.push(val.id);
                    })
                    formData.append('discharge_id', final_discharge)
                } else {
                    formData.append('discharge_id', this.selected_discharge_place)
                }
                //***************************************************
                console.log("selected truck is",this.selected_truck)
                if (this.selected_truck.includes(0)) {

                    var final_truck_id = [];
                    this.trucks.forEach(function (val) {
                        console.log("trucks zero added ",val)
                        final_truck_id.push(val.id);
                    })
                    formData.append('truck_id', final_truck_id)
                } else {
                    formData.append('truck_id', this.selected_truck)
                }
                //***************************************************
                if (this.selected_origin_load.includes(0)) {
                    var final_origin_load = [];
                    this.origin_loads.forEach(function (val) {
                        final_origin_load.push(val.id);
                    })
                    formData.append('origin_load_id', final_origin_load)
                } else {
                    formData.append('origin_load_id', this.selected_origin_load)
                }
                //***************************************************
                if (this.selected_load_type.includes(0)) {
                    var final_load_type = [];
                    this.load_types.forEach(function (val) {
                        final_load_type.push(val.id);
                    })
                    formData.append('load_type_id', final_load_type)
                } else {
                    formData.append('load_type_id', this.selected_load_type)
                }
                //***************************************************

                // formData.append('discharge_id', this.selected_discharge_place)
                // formData.append('truck_id', this.selected_truck)
                // formData.append('origin_load_id', this.selected_origin_load)
                // formData.append('load_type_id', this.selected_load_type)
                this.axios.post('/api/delivery_document/report_all', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items_delivery = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery.forEach(function (val) {
                            val.calculated_driver_price = self.real_paying_driver(val)
                            val.calculated_employer_price = self.deliver_employer(val)
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_discharge_places() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.discharge_places = [{id: 0, name: "همه موارد", code: ""}]
                        self.discharge_places_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.discharge_places = [];
                            response.data.data.forEach(function (val) {
                            self.discharge_places_all[0].children.push(val)
                            self.discharge_places.push(val)
                        })

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    if (self.$route.params.doc_id != null) {
                        self.status_form = self.$route.params.doc_id
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_trucks() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.trucks_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.trucks = []
                        response.data.data.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                        response.data.data.forEach(function (val) {
                            self.trucks_all[0].children.push(val)
                            self.trucks.push(val)
                        })


                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_origin_downloads() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.origin_loads = [{id: 0, name: "همه موارد", code: ""}]
                        // response.data.data.forEach(function (val) {
                        //     self.origin_loads.push(val)
                        // })
                        self.origin_loads_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.origin_loads = []
                        response.data.data.forEach(function (val) {
                            self.origin_loads_all[0].children.push(val)
                            self.origin_loads.push(val)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.load_types = [{id: 0, name: "همه موارد", code: ""}]
                        // response.data.data.forEach(function (val) {
                        //     self.load_types.push(val)
                        // })
                        self.load_types_all = [{id: 0, name: "همه موارد", code: "", children: []}]
                        self.load_types = []
                        response.data.data.forEach(function (val) {
                            self.load_types_all[0].children.push(val)
                            self.load_types.push(val)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    console.log(error)
                })

            },
            edit_item(item) {
                this.$router.push({path: '/edit-delivery-document/' + item.id})
            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id
            },
            delete_item() {
                const self = this
                const formData = new FormData()
                const url = '/api/delivery_document/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }
    }
</script>
